import _get from 'lodash/get';

export const getStartTime = (event) => _get(event, 'start.dateTime') || _get(event, 'start.date');
export const getEndTime = (event) => _get(event, 'end.dateTime') || _get(event, 'end.date');
export const getTitle = (event) => event && (event.summary || event.subject);
export const addDaysToCurrentDate = (days, currentDate = new Date()) => {
  const result = new Date(currentDate);
  result.setDate(result.getDate() + days);
  return result;
};

export const getLocation = (event) =>
  _get(event, 'location.displayName') || (typeof event.location === 'string' && event.location) || '';
export const getDescription = (event) =>
  _get(event, 'body.content') || (typeof event.description === 'string' && event.description) || '';
export const getOrganizer = (event) => _get(event, 'organizer.emailAddress.name') || _get(event, 'organizer.email');

export const startOfDay = (date) => new Date(date).setHours(0, 0, 0, 0);

export const endOfDay = (date) => new Date(date).setHours(23, 59, 59, 999);

export default {
  getStartTime,
  getEndTime,
  startOfDay,
  endOfDay,
  getTitle,
  getLocation,
  getDescription,
  getOrganizer,
  addDaysToCurrentDate
};
